import { render } from "./PetDetailDialog.vue?vue&type=template&id=55aa3b4a&scoped=true"
import script from "./PetDetailDialog.vue?vue&type=script&lang=js"
export * from "./PetDetailDialog.vue?vue&type=script&lang=js"

import "./PetDetailDialog.vue?vue&type=style&index=0&id=55aa3b4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aa3b4a"]])

export default __exports__